import { tss } from '@/shared/styles/tss'

export const useStyles = tss.withName('YourKeys').create(({ theme }) => ({
  root: {
    width: '100%',
    minHeight: '68px',
    padding: '16px',
    borderRadius: '12px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    background: 'rgba(17, 17, 17, 1)',
  },

  textAndBalanceWrapper: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
  },

  yourKeysText: {
    color: theme.colors.text.primary,
    fontSize: theme.sizes.texts.fontSize.m,
    lineHeight: '17px',
  },

  balanceAmount: {
    fontSize: theme.sizes.texts.fontSize.l,
    lineHeight: theme.sizes.texts.lineHeight.xl,
    color: theme.colors.text.golden,
  },

  balanceWrapper: {
    display: 'flex',

    gap: '4px',
  },

  button: {
    width: '30%',
    height: '36px',
    padding: '8px 16px',
    borderRadius: '24px',

    fontSize: '13px',
    lineHeight: theme.sizes.texts.lineHeight.m,
  },
}))
